module.exports = __webpack_public_path__ + "static/media/super-essencial.6307676e.svg";